import { provideHttpClient, withInterceptorsFromDi, withFetch, HTTP_INTERCEPTORS, HttpClient } from "@angular/common/http";
import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { MsalInterceptor, MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalService, MsalGuard, MsalBroadcastService } from "@azure/msal-angular";
import { MSALInstanceFactory } from "./utility/authentication/msal.util";
import { MSALGuardConfigFactory } from "./utility/authentication/msal.guard";
import { MSALInterceptorConfigFactory } from "./utility/interceptors/msal.interceptor";
import { LocationStrategy, HashLocationStrategy, DatePipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { BehaviorSubject } from "rxjs";
import { HttpLoaderFactory } from "src/main";
import { appRoutes } from "./app.routes";
import { AdminApiInterceptor } from "./utility/interceptors/admin-api.interceptor";
import { ErrorInterceptor } from "./utility/interceptors/error.interceptor";
import { getToken, USER_TOKEN } from "./utility/authentication/user-token.util";
import { UserToken } from "./common/interfaces/token/user-token";
import { LoaderInterceptor } from "./utility/interceptors/loader.interceptor";
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarConfig } from "@angular/material/snack-bar";

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        importProvidersFrom(BrowserModule, FormsModule, ReactiveFormsModule, MatSnackBarModule, TranslateModule.forRoot({
            defaultLanguage: 'en-US',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })),
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
        provideRouter(appRoutes),
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true,
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory,
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AdminApiInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true
        },
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy },
        {
            provide: USER_TOKEN,
            useValue: new BehaviorSubject<UserToken>(getToken())
        },
        {
            provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
            useValue: <MatSnackBarConfig>{
                duration: 5000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: ['mat-snack-accent-main']
            }
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        DatePipe,
    ],
};
